/**
 * Dashboard 차트 옵션 상수
 * 디자인 토큰 기반 색상/스타일 정의
 */

// 차트 색상 상수 — 디자인 토큰 미러링 (index.css :root 기준)
export const CHART_COLORS = {
  income: '#548164',    // --color-success
  expense: '#C4554D',   // --color-error
  primary: '#6366F1',   // --color-primary
  info: '#487CA5',      // --color-info
  warning: '#D97706',   // --color-warning
  categories: [
    '#6366F1', '#548164', '#487CA5', '#C4554D', '#D97706',
    '#787774', '#9CA3AF', '#373530'
  ]
};

// 탭 정의
export const CHART_TABS = [
  { key: 'category', label: '카테고리별', icon: 'pie_chart' },
  { key: 'weekday', label: '요일별', icon: 'date_range' },
  { key: 'heatmap', label: '히트맵', icon: 'grid_view' },
];

// 요일 라벨
export const WEEKDAY_LABELS = ['월', '화', '수', '목', '금', '토', '일'];

// 차트 공통 옵션 (Bar, Line)
export const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
    },
    datalabels: {
      display: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: function(value) {
          return value.toLocaleString('ko-KR') + '원';
        }
      }
    }
  },
};

// 저축률 차트 옵션
export const savingsChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
    },
    datalabels: {
      display: false,
    },
  },
  scales: {
    y: {
      ticks: {
        callback: function(value) {
          return value + '%';
        }
      },
      grid: {
        color: function(context) {
          if (context.tick.value === 0) {
            return '#373530';
          }
          return 'rgba(0, 0, 0, 0.06)';
        },
        lineWidth: function(context) {
          if (context.tick.value === 0) {
            return 2;
          }
          return 1;
        },
      },
    }
  },
};

// Pie 차트 옵션
export const pieOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'right',
      labels: {
        padding: 20,
        usePointStyle: true,
        pointStyle: 'circle',
        font: {
          size: 14,
          weight: '500'
        },
        color: '#373530',
        generateLabels: function(chart) {
          const data = chart.data;
          if (data.labels.length && data.datasets.length) {
            const sortedData = data.labels.map((label, i) => ({
              label,
              value: data.datasets[0].data[i],
              backgroundColor: data.datasets[0].backgroundColor[i],
              borderColor: data.datasets[0].borderColor[i],
              originalIndex: i
            })).sort((a, b) => b.value - a.value);

            const total = data.datasets[0].data.reduce((a, b) => a + b, 0);

            return sortedData.map((item) => {
              const percentage = ((item.value / total) * 100).toFixed(1);
              return {
                text: `${item.label} (${percentage}%)`,
                fillStyle: item.backgroundColor,
                strokeStyle: item.borderColor,
                lineWidth: 2,
                hidden: false,
                index: item.originalIndex
              };
            });
          }
          return [];
        }
      }
    },
    datalabels: {
      color: '#FFFFFF',
      font: {
        size: 12,
        weight: 'bold'
      },
      formatter: (value, context) => {
        const total = context.dataset.data.reduce((a, b) => a + b, 0);
        const percentage = ((value / total) * 100).toFixed(0);
        const label = context.chart.data.labels[context.dataIndex];

        if (percentage >= 5) {
          return `${label}\n${percentage}%`;
        }
        return '';
      },
      textAlign: 'center',
      anchor: 'center',
      textStrokeColor: '#373530',
      textStrokeWidth: 2
    },
    tooltip: {
      backgroundColor: 'rgba(55, 53, 48, 0.9)',
      titleColor: '#FFFFFF',
      bodyColor: '#FFFFFF',
      borderColor: '#E5E7EB',
      borderWidth: 1,
      cornerRadius: 12,
      displayColors: true,
      callbacks: {
        label: function(context) {
          const value = context.parsed;
          const total = context.dataset.data.reduce((a, b) => a + b, 0);
          const percentage = ((value / total) * 100).toFixed(1);
          return `${context.label}: ${value.toLocaleString('ko-KR')}원 (${percentage}%)`;
        }
      }
    }
  },
  interaction: {
    intersect: false,
    mode: 'nearest'
  },
  animation: {
    animateRotate: true,
    animateScale: true,
    duration: 1000
  }
};
